/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer">;
    readonly " $refType": "ReplyListContainer_viewer";
};
export type ReplyListContainer_viewer$data = ReplyListContainer_viewer;
export type ReplyListContainer_viewer$key = {
    readonly " $data"?: ReplyListContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '4d6f0d8b2067d4daa1278387011b4b24';
export default node;
